__turbopack_context__.v({
  "card": "CompareBarCard-module-scss-module__YJMXJG__card",
  "details": "CompareBarCard-module-scss-module__YJMXJG__details",
  "image": "CompareBarCard-module-scss-module__YJMXJG__image",
  "imageWrapper": "CompareBarCard-module-scss-module__YJMXJG__imageWrapper",
  "link": "CompareBarCard-module-scss-module__YJMXJG__link",
  "name": "CompareBarCard-module-scss-module__YJMXJG__name",
  "price": "CompareBarCard-module-scss-module__YJMXJG__price",
});
